import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import {
    isContainAlphabet
  } from "../../../services/common/utils";
function ViewSupportedCountriesSlider({data, psmItem, sourceId, handleClick, setShowBottomModal}) {
    const navigate  = useNavigate();
    const [show, setShow] = useState(true);
    const [dataList , setDatalist] = useState([]);
    const handleViewDealClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        navigate(`/roaming_product_details/${data?.offerid}`, {
            state: { psmItem: psmItem, sourceId: sourceId , flag:true}, 
        })
    };

    useEffect(()=>{
        if(data){
            let count = data?.supportedcountries?.popup?.countries.length;
            let temp = [];
            while(count > 0){
                data?.supportedcountries?.popup?.countries.slice(0,3);
                temp.push(data?.supportedcountries?.popup?.countries.slice(data?.supportedcountries?.popup?.countries?.length-count,data?.supportedcountries?.popup?.countries?.length-count + 3));
                count = count-3
            }
            setDatalist(temp)
        }
    }, [data?.supportedcountries?.popup?.countries])

    return(
        <Modal
                show={show}
                backdrop="true"
                className="modal fade bottom_modal animated slideInUp forget-password-popup comp-sec-popup sprint14-modal show"
                onHide={()=> {setShowBottomModal(false)}}
            >
                <Modal.Header className="border-0 p-0">
                    
                    <div class="modal_img w-100">
                        <h5>{data?.supportedcountries?.popup?.title}</h5>
                            <img class="btn-close"
                            onClick={handleClick}
                                src={process.env.PUBLIC_URL + '/assets/images/cross_dark.svg'}
                                alt=""
                                title=""
                            />
                    </div>
             
                </Modal.Header>
                <Modal.Body>
                <div class="modal-body text-left">
                    

                    <div class="country-logo-comp">
                        <div>
                            <div  class="country-logo-row">
                         
                            {dataList?.map((item, index) => 
                                <>
                                    <div className='country-row'>
                                        { item?.map((obj, index) => (
                                            <div class="country-cont text-ellipsis d-flex align-items-center">
                                                <img src={obj?.icon} alt="" title="" />
                                                <label className={isContainAlphabet(obj?.country) ? "" : "txt_right"}> {obj?.country} </label>
                                            </div>
                                        ))}
                                    </div>
                                    {item?.length >= 3 && <hr/>}
                                </>
                            )}
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-center mt-5 mb-4">
                            <button class="custom_btn custom_btn_primary btn_block"
                                style={{ textTransform: 'initial' }}
                                onClick={ handleViewDealClick}> {data?.supportedcountries?.popup?.btntext} </button>
                        </div>
                    </div>

                </div>
                </Modal.Body>
            </Modal>
    )
}

export default ViewSupportedCountriesSlider;